module.exports = __webpack_public_path__ + "media/styles/images/svg/plus-teal-slim-1a4671a5c696ac80751e5caf419d5dc1.svg";